import { render, staticRenderFns } from "./AIEstheHistoryTable.vue?vue&type=template&id=4a0edd6d&scoped=true&"
import script from "./AIEstheHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./AIEstheHistoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0edd6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
